import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeRedaction: 0,
    activeLetter: 's',
    cursor: 1,
    circleVisibility: false,
    isMobile: false
  },
  mutations: {
    storeActiveLetter: function(state, val) {
      state.activeLetter = val;
    },

    storeActiveRedaction: function(state, val) {
      state.activeRedation = val;
    },

    storeCursor: function(state, val) {
      state.cursor = val;
    },

    storeCircleVisibility: function(state, val) {
      state.circleVisibility = val;
    },

    storeMobile: function(state, val) {
      state.isMobile = val;
    }
  },
  actions: {
    setActiveLetter({ commit }, val) {
      commit("storeActiveLetter", val);
    },

    setActiveRedaction({ commit }, val) {
      commit("storeActiveRedaction", val);
    },

    setCursor({ commit }, val) {
      commit("storeCursor", val);
    },

    setCircleVisibility({ commit }, val) {
      commit("storeCircleVisibility", val);
    },

    setMobile({ commit }, val) {
      commit("storeMobile", val);
    }
  },
  getters: {
    getActiveLetter(state) {
      return state.activeLetter;
    },

    getActiveRedaction(state) {
      return state.activeRedaction;
    },

    getCursor(state) {
      return state.cursor;
    },

    getCircleVisibility(state) {
      return state.circleVisibility;
    },

    getMobile(state) {
      return state.isMobile;
    },
  }
});
